import { render, staticRenderFns } from "./editsmsconfig.vue?vue&type=template&id=f861ae9a&"
import script from "./editsmsconfig.vue?vue&type=script&lang=ts&"
export * from "./editsmsconfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "editsmsconfig.vue"
export default component.exports